import PropTypes from 'prop-types';

const DirectorIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g fill={fill} fillRule="nonzero">
        <path d="M21,48 C23.9582563,47.3321615 26.7727931,46.1392855 29.31,44.478 C34.394263,41.1476508 38.2829365,36.2815539 40.41,30.588 C41.4622309,27.7977253 42.0009079,24.8400835 42,21.858 L42,8.781 L21,0 L3.55271368e-15,8.784 L3.55271368e-15,21.855 C3.55271368e-15,24.852 0.528,27.762 1.587,30.585 C3.71406349,36.2785539 7.60273703,41.1446508 12.687,44.475 C15.237,46.146 18.009,47.319 21,48 Z M28.983,33.702 L21,29.31 L13.017,33.702 L15.204,25.329 L8.202,19.71 L17.391,18.894 L21,10.929 L24.609,18.894 L33.798,19.608 L26.796,25.329 L28.986,33.702 L28.983,33.702 Z M21,48 C23.9582563,47.3321615 26.7727931,46.1392855 29.31,44.478 C34.394263,41.1476508 38.2829365,36.2815539 40.41,30.588 C41.4622309,27.7977253 42.0009079,24.8400835 42,21.858 L42,8.781 L21,0 L3.55271368e-15,8.784 L3.55271368e-15,21.855 C3.55271368e-15,24.852 0.528,27.762 1.587,30.585 C3.71406349,36.2785539 7.60273703,41.1446508 12.687,44.475 C15.237,46.146 18.009,47.319 21,48 Z M28.983,33.702 L21,29.31 L13.017,33.702 L15.204,25.329 L8.202,19.71 L17.391,18.894 L21,10.929 L24.609,18.894 L33.798,19.608 L26.796,25.329 L28.986,33.702 L28.983,33.702 Z" />
      </g>
    </svg>
  </div>
);

DirectorIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

DirectorIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default DirectorIcon;
